import { rowsToCondition } from '../../../model/condition/rows.js'

/**
 * Builds a condition object from editable rows.
 *
 * Config shape:
 * {
 *     logicType: 'calcFields',
 *     operationType: 'header.buildCondition',
 *     sourceArray: 'conditions',   // rows of { field, operator, value, valueType }
 *     targetField: 'match'
 * }
 *
 * The rows are the edited form; the target is what an evaluator reads. Only a
 * record that HAS the rows array is touched — one without it (a rule whose
 * condition the rows cannot express, or one written before rows existed) keeps
 * its condition exactly as stored. An array with no usable rows clears the
 * condition, which is how a catch-all is written.
 */
const headerBuildCondition = (data, operation) => {
    const { sourceArray, targetField } = operation
    if (!sourceArray || !targetField) return data
    if (!Array.isArray(data?.[sourceArray])) return data
    return { ...data, [targetField]: rowsToCondition(data[sourceArray]) }
}

export default headerBuildCondition
